var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProfil = function SvgProfil(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none",
    viewBox: "-1 -1 28 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M12.81 12.11a2.69 2.69 0 1 0-2.69-2.69 2.64 2.64 0 0 0 2.69 2.69ZM8.84 18.76v-1.29a2.28 2.28 0 0 1 .82-1.86 2.7 2.7 0 0 1 1.86-.82h2.69a2.28 2.28 0 0 1 1.86.82 2.7 2.7 0 0 1 .82 1.86v1.29"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.81,
    cy: 12.81,
    r: 12.51,
    stroke: "currentColor"
  })));
};
export default SvgProfil;